import axios from 'axios';
import { getTokens } from './AuthenticationService';

const instance = axios.create();

instance.interceptors.request.use(
  async (config) => {
    const tokens = getTokens();

    const isTokenReq = typeof config.data === 'string' && config.data.includes('grant_type');

    if (tokens && tokens.accessToken && tokens.accessToken !== '' && !isTokenReq)
      config.headers.Authorization = `Bearer ${tokens.accessToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // removeToken();
    // console.log(error);

    if (error.response && error.response.status === 401) {
      // removeTokens();
      console.log('Unauthorized');
      //window.location.pathname = "/";
      // window.location.reload();
    }

    return Promise.reject(error);
  }
);

export default instance;
